/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../../core/AppDispatcher'
import ApiClient from '../../ApiClient'
import LoginApi from '../../api/LoginApi'
import ApiHandle from '../../util/ApiHandle'
import { appActions } from '../../action/AppActions'

const loginApi = new LoginApi(ApiClient.instance)

export const PasswordResetActionTypes = {
  handleEmailEdit: 'passwordReset/email-edited',
  handlePasswordEdit: 'passwordReset/password-edited',
  sendLink: 'passwordReset/link-sent',
  passwordUpdated: 'passwordReset/password-updated'
}

const passwordResetActions = {
  onEmailEdit: function(email) {
    AppDispatcher.dispatchWithType(PasswordResetActionTypes.handleEmailEdit, { email: email })
  },
  onPasswordEdit: function(e) {
    AppDispatcher.dispatchWithType(PasswordResetActionTypes.handlePasswordEdit, {
      name: e.target.name,
      value: e.target.value
    })
  },

  sendLink: function(email) {
    const opts = { body: { user: { email: email } } }
    const apiHandleOpts = {
      apiCall: () => loginApi.passwordResetRequest(opts),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(PasswordResetActionTypes.sendLink)
        appActions.snackbar('パスワードリセットメールを送信しました', 'success', false)
      },
      onFailed: response => appActions.snackbar('パスワードリセットメールの送信に失敗しました', 'error', false),
      onErrored: error => appActions.snackbar('パスワードリセットメールの送信に失敗しました', 'error', false)
    }
    ApiHandle(apiHandleOpts)
  },

  updatePassword: function(reset_password_token, password, passwordConf) {
    if (password !== passwordConf) {
      appActions.snackbar('パスワードが一致しません', 'error', false)
      return
    }

    const opts = {
      body: {
        user: {
          reset_password_token: reset_password_token,
          password: password
        }
      }
    }

    const apiHandleOpts = {
      apiCall: () => loginApi.passwordResetUpdate(opts),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(PasswordResetActionTypes.passwordUpdated)
        appActions.snackbar('パスワードを変更しました', 'success', false)
      },
      onFailed: response => appActions.snackbar('パスワードの変更に失敗しました', 'error', false),
      onErrored: error => appActions.snackbar('パスワードの変更に失敗しました', 'error', false)
    }
    ApiHandle(apiHandleOpts)
  }
}

export default passwordResetActions
